// extracted by css-extract-rspack-plugin
export default {"wrapperCard":"DashboardAlertsWindow_wrapperCard__0HIMH","innerStub":"DashboardAlertsWindow_innerStub__Emufd","header":"DashboardAlertsWindow_header__V_E4a"};